import { ShadowTokenValue } from 'designSystem/types';
import * as S from './styles';

interface ShadowTokenPreviewProps {
	value: ShadowTokenValue;
}

export const ShadowTokenPreview = ({ value }: ShadowTokenPreviewProps) => {
	const shadowStyle = `${value.offsetX}px ${value.offsetY}px ${value.blur}px ${
		value.spread || 0
	}px ${value.color.hex}`;

	return (
		<S.PreviewContainer>
			<S.ShadowBox shadow={shadowStyle} />
			<S.ValueText>{value.original}</S.ValueText>
		</S.PreviewContainer>
	);
};
